<template>
    <div class="toggle-switch__legislation">
        <input
            v-model="subscribedLegislation"
            class="toggle-switch__input"
            type="checkbox"
        />
        <label
            class="d-block  mr-2 mb-2 mb-md-0"
            @click="changeLegislationSubscription"
        >
            <span>{{ legislation.name }}</span>
        </label>
    </div>
</template>

<script>
import Axios from 'axios';
export default {
    props: {
        legislation: {
            type: Object,
            default() {
                return {};
            }
        }
    },

    data() {
        return {
            subscribedLegislation: false
        };
    },
    watch: {
        myNews() {
            if (
                !this.firstLoadMyNotifications &&
                !this.firstLoadGetSubscriptions
            ) {
                this.updateNotificationPreferences();
            }
        },
        'legislation.isSubscribed'(val) {
            this.subscribedLegislation = val;
        }
    },
    mounted() {
        this.subscribedLegislation = this.legislation.isSubscribed;
    },

    methods: {
        changeLegislationSubscription() {
            if (this.subscribedLegislation) {
                this.subscribedLegislation = false;
                const url =
                    '/umbraco/api/legislation/unsubscribeFromLegislation';
                Axios({
                    method: 'post',
                    url: url,
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: this.legislation.id
                });
            } else {
                this.subscribedLegislation = true;
                const url = '/umbraco/api/legislation/subscribeToLegislation';
                Axios({
                    method: 'post',
                    url: url,
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: this.legislation.id
                });
            }
        }
    }
};
</script>

<style lang="scss">
.toggle-switch__legislation {
    flex: 0 1 33.3333%;
}

.toggle-switch__legislation label {
    font-size: 0.85rem;
    margin-bottom: 0;
    position: relative;

    &:before {
        content: '';
        display: inline-block;
        width: 16px;
        height: 16px;
        background-color: $brand-gray;
        border: 1px solid #dadada;
        vertical-align: middle;
        margin-right: 0.5rem;
        position: absolute;
        left: 0;
        top: 5px;
    }
}

input.toggle-switch__input:checked + label {
    &:before {
        content: '\2713';
        display: inline-block;
        width: 16px;
        height: 16px;
        background-color: $brand-white;
        color: $brand-green;
        border: 1px solid #dadada;
        text-align: center;
        margin-right: 0.5rem;
        line-height: 1;
        font-weight: bold;
    }
}

.toggle-switch__legislation label span {
    display: block;
    padding-left: 25px;
}

.toggle-switch--small {
    width: 36px;
    height: 18px;

    &:before {
        height: 12px;
        width: 12px;
    }
}

.toggle-switch--small:before {
    input:checked + & {
        transform: translateX(16px);
    }
}
</style>
